var map = {
	"./reward_rules_cn.png": 1110,
	"./reward_rules_en.png": 1111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1411;



//////////////////
// WEBPACK FOOTER
// ./static/img/rewardRules ^\.\/.*\.png$
// module id = 1411
// module chunks = 1